import PostsAdapter from './base';

export default class TagCategory extends PostsAdapter {
  modelNamePlural = 'tagCategories';
}
